import React from 'react';
import LedgerForm from '@/components/forms/master/account/ledger/LedgerForm';
import GlobalFormModal from '@/utils/modal/GlobalFormModal';
import ItemForm from '@/components/forms/master/inventory/item/ItemForm';

const ModalManager = ({ visibleModal, closeModal }) => {
  const closeModalHandler = (modalKey) => {
    closeModal(modalKey); // Close the specific modal dynamically
  };

  const renderModalContent = (modalKey) => {
    switch (modalKey) {
      case 'ledgerModal':
        return <LedgerForm onClose={() => closeModalHandler('ledgerModal')} />;
      case 'itemModal':
        return <ItemForm onClose={() => closeModalHandler('itemModal')} />;
      // Add other cases for additional modals
      default:
        return null;
    }
  };

  return (
    <div>
      {Object?.keys(visibleModal)?.map((modalKey) => {
        if (visibleModal[modalKey]) {
          return (
            <GlobalFormModal
              key={modalKey}
              isVisible={visibleModal[modalKey]}
              onClose={() => closeModalHandler(modalKey)}
              title={
                modalKey === 'ledgerModal' ? 'Create Ledger' : 'Create Item'
              } // Customize titles for each modal
            >
              {renderModalContent(modalKey)}
            </GlobalFormModal>
          );
        }
        return null;
      })}
    </div>
  );
};

export default ModalManager;
